<form [formGroup]="mostImportantActivitiesEntityDescriptionFg">
  <div class="row">
    <div class="col col-1 pt-3" style="width: 400px">
      <p style="padding: 6px">Beschrijving van de belangrijkste activiteiten van de onderneming</p>
    </div>
    <div class="col-2 pt-3">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.mostImportantActivitiesEntityDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(1)">
        {{ this.mostImportantActivitiesEntityDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    @if (isRechtspersoon) {
      <div class="col-3">
        <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                          label="In publicatiestukken"
                                          [options]="this.optionsJaNee"
                                          [required]=true
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </div>
</form>
<form [formGroup]="locationActualActivitiesDescriptionFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Beschrijving van de locatie van de feitelijke activiteiten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.locationActualActivitiesDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(2)">
        {{ this.locationActualActivitiesDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    @if (isRechtspersoon) {
      <div class="col-3">
        <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                          [options]="this.optionsJaNee"
                                          [required]=true
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </div>
</form>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.mostImportantActivitiesEntityDescriptionFg"
                                                               [title]="'Beschrijving van de belangrijkste activiteiten van de onderneming'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.locationActualActivitiesDescriptionFg"
                                                               [title]="'Beschrijving van de locatie van de feitelijke activiteiten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
